if (module.hot) {
  module.hot.accept();
}

// import { initCursor } from "./cursor";
import { initNav } from "./nav";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, DrawSVGPlugin);

let mm = gsap.matchMedia();

function init() {
  // initCursor();
  initNav();
}

window.addEventListener("load", function () {
  init();
});

mm.add("(min-width: 768px)", () => {
  ScrollSmoother.create({
    smooth: 1,
    effects: true,
    smoothTouch: 0.1,
    normalizeScroll: true,
  });

  // Draw Hero Image
  gsap.from(".mk-hero__image path", {
    duration: 8,
    drawSVG: "0%",
    ease: "slow(0.7, 0.7, false)",
    fill: "transparent",
  });
  gsap.to(".mk-hero__image", {
    opacity: 1,
  });

  ScrollTrigger.create({
    trigger: ".year-num-1854",
    start: "top 20%",
    end: "bottom 40%",
    pin: true,
    pinSpacing: false,
    scrub: true,
    // markers: true,
  });

  // 1856 Scroll Trigger
  ScrollTrigger.create({
    trigger: ".year-num-1856",
    start: "top 20%",
    end: "bottom 40%",
    pin: true,
    pinSpacing: false,
    scrub: true,
    // markers: true,
  });

  // 1867 Scroll Trigger
  ScrollTrigger.create({
    trigger: ".year-num-1867",
    start: "top 20%",
    end: "bottom 40%",
    pin: true,
    pinSpacing: false,
    scrub: true,
    // markers: true,
  });

  // 1871 Scroll Trigger
  ScrollTrigger.create({
    trigger: ".year-num-1871",
    start: "top 20%",
    end: "bottom 40%",
    pin: true,
    pinSpacing: false,
    scrub: true,
    // markers: true,
  });

  // POPULAR HEALING SCROLLING HEADERS ANIMATION
  const scrolling_headers_animation = gsap
    .timeline({ paused: "true" })
    .to("#scrolling-header--big", { xPercent: -400, ease: "none" })
    .to("#scrolling-header--small", { xPercent: 400, ease: "none" }, "<");

  ScrollTrigger.create({
    trigger: "#scrolling-header--big",
    animation: scrolling_headers_animation,
    start: "top 80%",
    end: "bottom -=500",
    scrub: 1,
    // markers: true,
  });

  // DISEASE & WAR SCROLLING HEADERS ANIMATION
  const scrolling_headers_animation_disease_war = gsap
    .timeline({ paused: "true" })
    .to("#scrolling-header-disease-war--big", { xPercent: -400, ease: "none" })
    .to(
      "#scrolling-header-disease-war--small",
      { xPercent: 400, ease: "none" },
      "<"
    );

  ScrollTrigger.create({
    trigger: "#scrolling-header-disease-war--big",
    animation: scrolling_headers_animation_disease_war,
    start: "top 80%",
    end: "bottom -=500",
    scrub: 1,
    // markers: true,
  });

  // BERIBERI SCROLLING HEADERS ANIMATION
  const scrolling_headers_animation_beriberi = gsap
    .timeline({ paused: "true" })
    .to("#scrolling-header-beriberi--big", { xPercent: -400, ease: "none" })
    .to(
      "#scrolling-header-beriberi--small",
      { xPercent: 400, ease: "none" },
      "<"
    );

  ScrollTrigger.create({
    trigger: "#scrolling-header-beriberi--big",
    animation: scrolling_headers_animation_beriberi,
    start: "top 80%",
    end: "bottom -=500",
    scrub: 1,
    // markers: true,
  });

  // KARL FRIEDRICH QUOTE ANIMATION
  const timeline_quote = gsap
    .timeline({ paused: "true" })
    .fromTo(".timeline__quote--karl-fridrich", { scale: 0 }, { scale: 1 });

  ScrollTrigger.create({
    trigger: ".section--timeline__quote--karl-friedrich",
    animation: timeline_quote,
    start: "top 60px",
    end: "bottom 600px",
    pin: true,
    // pinSpacing: false,
    scrub: 1,
    anticipatePin: 1,
    // markers: true,
  });

  // PAI MANOEL QUOTE ANIMATION
  const timeline_quote_pai_manoel = gsap
    .timeline({ paused: "true" })
    .fromTo(".timeline__quote--pai-manoel", { scale: 0 }, { scale: 1 });

  ScrollTrigger.create({
    trigger: ".section--timeline__quote--pai-manoel",
    animation: timeline_quote_pai_manoel,
    start: "top 60px",
    end: "bottom 600px",
    pin: true,
    // pinSpacing: false,
    scrub: 1,
    anticipatePin: 1,
    // markers: true,
  });

  // DISEASES & WAR QUOTE
  const timeline_quote_diseases_war = gsap
    .timeline({ paused: "true" })
    .fromTo(".timeline__quote--diseases-war", { scale: 0 }, { scale: 1 });

  ScrollTrigger.create({
    trigger: ".section--timeline__quote--diseases-war",
    animation: timeline_quote_diseases_war,
    start: "top 60px",
    end: "bottom 600px",
    pin: true,
    // pinSpacing: false,
    scrub: 1,
    anticipatePin: 1,
    // markers: true,
  });

  // BERIBERI QUOTE
  const timeline_quote_beriberi = gsap
    .timeline({ paused: "true" })
    .fromTo(".timeline__quote--beriberi", { scale: 0 }, { scale: 1 });

  ScrollTrigger.create({
    trigger: ".section--timeline__quote--beriberi",
    animation: timeline_quote_beriberi,
    start: "top 60px",
    end: "bottom 600px",
    pin: true,
    // pinSpacing: false,
    scrub: 1,
    anticipatePin: 1,
    // markers: true,
  });
});

// mm.add("(min-width: 768px)", () => {
//   ScrollTrigger.create({
//     trigger: ".section--theme-lead-in",
//     animation: theme_lead_in_animation_tl,
//     start: "top 20%",
//   });
// });

// Draw Theme Lead In
const theme_lead_in_animation_tl = gsap.timeline({ paused: "true" });
theme_lead_in_animation_tl.from(".theme-lead-in__image path", {
  duration: 4,
  drawSVG: "0%",
  ease: "slow(0.7, 0.7, false)",
});
theme_lead_in_animation_tl.to(
  ".theme-lead-in__wrapper",
  {
    opacity: 1,
  },
  0
);

theme_lead_in_animation_tl.to(".theme-lead-in__image .cls-1", {
  fill: "#191919",
  duration: 2,
});

theme_lead_in_animation_tl.to(
  ".theme-lead-in__arrow-right",
  {
    width: "100%",
    duration: 0.5,
  },
  "<.5"
);

theme_lead_in_animation_tl.to(
  ".theme-lead-in__next",
  {
    opacity: 1,
    duration: 1,
  },
  "<+.5"
);

ScrollTrigger.create({
  trigger: ".section--theme-lead-in",
  animation: theme_lead_in_animation_tl,
  start: "top 20%",
});
